import { render, staticRenderFns } from "./fenshen.vue?vue&type=template&id=50a5bf74&scoped=true&"
import script from "./fenshen.vue?vue&type=script&lang=js&"
export * from "./fenshen.vue?vue&type=script&lang=js&"
import style0 from "./fenshen.vue?vue&type=style&index=0&id=50a5bf74&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a5bf74",
  null
  
)

export default component.exports